export function getIsInternalUrl(localhostOnly = false) {
  return [
    "localhost:3000",
    ...(localhostOnly ? [] : ["fledge-develop.dev-corv.us"]),
    ...(localhostOnly ? [] : ["fledge.raven.ai"]),
  ].includes(window.location.host);
}

export type CustomerListItem = {
  abbrevName: string;
  customerName?: string;
};
export const WHICH_CONFIGS_OPTIONS: WhichConfigsType[] = [
  "flightConfig",
  "workSchedules",
  "askrConfig",
  "customerInfo",
];
export type WhichConfigsType =
  | "flightConfig"
  | "workSchedules"
  | "askrConfig"
  | "customerInfo";
